import React from 'react';

const InputError = ({errorMessage}) => {
  return !errorMessage ? null : <div className="inputwitherror__error-text">{errorMessage}</div>;
};

export default InputError;
